import "./select.scss";

function SelectField({
  label,
  options,
  defaultValue,
  register,
  name,
  padding,
}) {
  return (
    <select
      className="form-select"
      defaultValue={defaultValue}
      style={{ padding: padding }}
      {...register(name)}
    >
      <option value="">{label}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export default SelectField;
